export const GET_DATA_KEY="SET_DATA";
export const SET_DATA_KEY="SET_DATA_KEY";
export const GET_DATA ="GET_DATA";
export const SET_DATA ="SET_DATA";
export const GET_ALL ="GET ALL"
